<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-07 18:43:36
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-02-15 10:22:05
 * @name: 设置
 * @Description: 设置
 * @FilePath: \preSaleNafterSaleBackstage\src\views\setting\setting.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <layout-normal>
    <el-tabs :value="'base'">
      <el-tab-pane label="基础配置" name="base">
        <div class="form">
          <font class="title">出账日设置</font>
          <div class="line">
            <font>每月</font>
            <el-select
              class="date"
              size="mini"
              v-model="settingClass.settle_day"
            >
              <el-option
                v-for="index in 28"
                :key="index"
                :label="String(index).padStart(2, '0')"
                :value="String(index).padStart(2, '0')"
              >
              </el-option>
            </el-select>
            <font>日，出账单。</font>
          </div>
          <font class="title">还账日设置</font>
          <div class="line">
            <font>出账日后</font>
            <el-select
              class="date"
              size="mini"
              v-model="settingClass.settle_limit_day"
            >
              <el-option
                v-for="index in 15"
                :key="index"
                :label="String(index)"
                :value="String(index)"
              >
              </el-option>
            </el-select>
            <font>日内，经销商需还清本期账期，否则无法购买商品。</font>
          </div>
          <font class="title">公司账户信息</font>
          <div class="line">
            <font class="label">公司账户</font>
            <el-input
              size="mini"
              v-model="settingClass.account"
              placeholder="请输入公司账户"
            ></el-input>
          </div>
          <div class="line">
            <font class="label">公司户名</font>
            <el-input
              size="mini"
              v-model="settingClass.account_name"
              placeholder="请输入公司户名"
            ></el-input>
          </div>
          <div class="line">
            <font class="label">收款银行</font>
            <el-input
              size="mini"
              v-model="settingClass.bank"
              placeholder="请输入收款银行"
            ></el-input>
          </div>
          <el-button class="submit" type="primary" @click="submit"
            >提交</el-button
          >
        </div>
      </el-tab-pane>
    </el-tabs>
  </layout-normal>
</template>
<script>
import { debounceation } from "@/utils/decorator";
import settingClass from "@/object/setting/setting.class.js";
export default {
  name: "setting",
  data() {
    return {
      settingClass: new settingClass(),
    };
  },
  activated() {
    this.getMsg();
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取信息
     */
    getMsg() {
      this.settingClass.getSysConfigDetail();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击提交
     */
    @debounceation(300)
    submit() {
      let { settle_day, settle_limit_day, account, account_name, bank } =
        this.settingClass;
      let params = {
        settle_day,
        settle_limit_day,
        account,
        account_name,
        bank,
      };
      this.settingClass.sysConfigEdit(params);
    },
  },
};
</script>
<style lang="scss" scoped>
.el-tabs {
  width: 100%;
  .form {
    padding: 20px;
    box-sizing: border-box;
    @extend .extend-flex-column-normal;
    .title {
      font-size: $Vars-font-miniTitle-size;
      color: $Vars-font-important-color;
      margin-top: 30px;
    }
    .line {
      margin: 20px 0;
      @extend .extend-flex-start;
      font-size: $Vars-font-miniContent-size;
      color: $Vars-font-normal-color;
      .date {
        margin: 0 20px;
      }
      .label {
        width: 100px;
      }
    }
    .submit {
      width: 120px;
      margin: 40px auto;
    }
  }
}
</style>